module.exports = __webpack_public_path__ + "static/media/fashion.30a96cc6.png";